import React, { useState } from "react";
import Measurement1 from "./Measurement/Measurement";
import Childcare1 from "./Childcare/Childcare";

const Growth1 = () => {
  const [activeTab, setActiveTab] = useState("Measurement");

  const renderComponent = () => {
    switch (activeTab) {
      case "Measurement":
        return <Measurement1 />;
      case "Childcare":
        return <Childcare1 />;
      default:
        return null;
    }
  };

  return (
    <div className=" h-full px-3 py-3">
      {/* <h3 className="text-2xl font-extrabold mb-2 ">24th Weeks</h3> */}
      <ul className="flex mx-3">
        <li
          className={`w-full text-center border-b-2 ${
            activeTab === "Measurement" ? "border-header" : "border-dark"
          }`}
          onClick={() => setActiveTab("Measurement")}
        >
          <span
            className={`inline-block p-3 text-lg cursor-pointer font-bold ${
              activeTab === "Measurement" ? "text-header" : "text-dark"
            }`}
          >
            Measurement
          </span>
        </li>
        <li
          className={`w-full text-center cursor-pointer border-b-2 ${
            activeTab === "Childcare" ? "border-header" : "border-dark"
          }`}
          onClick={() => setActiveTab("Childcare")}
        >
          <span
            className={`inline-block p-3 text-lg font-bold ${
              activeTab === "Childcare" ? "text-header" : "text-dark"
            }`}
          >
            Childcare
          </span>
        </li>
      </ul>

      <div className="mt-3 px-2">{renderComponent()}</div>
    </div>
  );
};

export default Growth1;
